<div tabindex="0" attr.id="{{ identity }}" attr.aria-label="Clickable toggle {{ aria }}" class="switch" [ngClass]="{'switch--on': state}" (activate)="toggle()">
  <div [attr.class]="'switch__background switch__background--' + style"></div>
  <div class="switch__fob"></div>
</div>
